var token = '';
var count = '';
var swiperIndex = 0;
var indexArr = ['main', 'worldview', 'feature'];
var indexObj = {
    main: 0,
    registration: 1,
    worldview: 2,
    feature: 3,
    event: 4,
    archive: 6,
};
var indexobj = {
    1: 'main',
    2: 'worldview',
    3: 'feature',
};
var links = {
    service_agreement: 'https://law.qcplay.co.kr/ko-kr/service_agreement.html',
    privacy_policy: 'https://law.qcplay.co.kr/ko-kr/privacy_policy.html',
    Naver: 'https://game.naver.com/lounge/supersnail/home',
    YTB: 'https://www.youtube.com/channel/UCuQlUk5enYeww2ZntXMacJA',
    facebook: 'https://www.facebook.com/TheMarvelousSnail/',
    Discord: 'https://discord.gg/CqjPFG5qHa',
    iOS: 'https://apps.apple.com/app/id1491859159',
    Android: 'https://play.google.com/store/apps/details?id=com.ltgames.android.snail',
    pay: 'https://pay.snell.com.tw/pay?gameId=120',
    active: 'https://h5.snell.com.tw/snail_5thSpecial/enter',
};
var snail_obj = {
    snail: 1,
    shell: 0,
    imgSrc: 'https://download4.qcplay.com/snail-doubleDan/doubleDan/',
};
var obj = {
    index: function() {
        obj.swiper();
        this.countNum('港澳台官网_打开页面_PC');
        this.bing();
        $(window).trigger('resize');
    },

    indexAjax: function(options) {},
    bing: function() {
        $('.tag').click(function(e) {
            var tag = $(this).attr('tag');
            tag = tag * 1;
            console.log(tag);
            $(`.tools_${tag}`).fadeIn();
            $(`.tools_${tag}`).siblings().fadeOut();
        });
        $('.snail_click').click(function() {
            var data = $(this).attr('all_snail');
            console.log(data);
            $('.snail_active').removeClass(function(index, className) {
                return (className.match(/snail_active_\d+/) || []).join(' ');
            });
            $('.snail_active')
                .addClass(`snail_active_${data}`)
                .each(function() {
                    setTimeout(function() {
                        $('.head').fadeOut();
                        $('.swiper-container-snail').addClass(
                            'swiper-container-snail_show'
                        );
                        obj.snailSwipwer.slideTo(data, 0, false);
                    });
                });
        });

        $('.next').click(function(event) {
            event.stopPropagation();
        });
        $('.prev').click(function(event) {
            event.stopPropagation();
        });
        $('.snail_active').click(function() {
            $('.snail_active').fadeOut();
        });
        $('.swiper-slide').on('click', '.main_item', function(event) {
            event.stopPropagation();
            var data = $(this).attr('main_item_data');
            $('.main_mask').fadeIn();
            console.log(data);
            $('.main_item').each(function() {
                $(this).attr('class', 'main_item');
            });
            $(this)
                .addClass(`main_item_${data}`)
                .each(function(event) {
                    const $mapBox = $('.map_box_pop');
                    $mapBox.removeClass(function(index, className) {
                        return (className.match(/map_box_pop_\d+/) || []).join(' ');
                    });
                    $mapBox.addClass(`map_box_pop_${data}`);
                    $('.map_wrap').fadeIn();
                });
        });

        $('.map_wrap').click(function() {
            $('.map_wrap').fadeOut();
            $('.main_mask').fadeOut();
        });

        $('.swiper-slide').on('click', '.close_wrapper', function(event) {
            $('.head').fadeIn();
            $('.swiper-container-snail').removeClass('swiper-container-snail_show');
            $('.snail_active').fadeOut();
        });

        let that = this;

        that.links = links;
        $('.pay').click(function() {
            obj.countNum('港澳台官网_官网重充值_PC');
            window.open(links.pay, '_blank');
            // layer.msg('即將到來，敬請期待');
        });
        $('.link').click(function() {
            let data = $(this).attr('link');
            window.open(links[data], '_blank');
        });
        $('.load').click(function() {
            function getMobileOperatingSystem() {
                const userAgent =
                    navigator.userAgent || navigator.vendor || window.opera;

                if (/android/i.test(userAgent)) {
                    return 'Android';
                }

                if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                    return 'iOS';
                }

                return 'Android';
            }

            const os = getMobileOperatingSystem();
            window.open(links[os], '_blank');
        });

        $('.popup_wrap .close_wrapper').click(function() {
            $('.popup_wrap').fadeOut();
        });
        $('.video_wrap .close_wrapper').click(function() {
            var Media = $('#media-play');
            $('.video_wrap').fadeOut();
            Media.attr('src', '');
        });

        let menu_items = $('.menu_item').toArray();
        let windowHeight = $(window).height();
        menu_items.forEach((element, index) => {
            let scroollHeight = index * windowHeight;
            onScrollToHeight(scroollHeight, function() {
                const scrollIndex = Math.round($(window).scrollTop() / windowHeight);
                $(menu_items[scrollIndex])
                    .addClass('active')
                    .siblings()
                    .removeClass('active');
            });
        });

        function onScrollToHeight(height, callback) {
            $(window).on('scroll', function() {
                let maxH = height + 200;
                if ($(window).scrollTop() >= height && $(window).scrollTop() < maxH) {
                    callback();
                }
            });
        }
        $('.menu_item').click(function(e) {
            var data = $(this).attr('data');
            let menu_item = $(this).closest('.menu_item');
            let index = $('.menu_item').index(menu_item);
            $('html, body').animate({
                    scrollTop: $(window).height() * index,
                },
                500
            );
            setTimeout(() => {
                $(this).addClass('active').siblings().removeClass('active');
            }, 500);
        });
        $('.privacy_policy').click(function(event) {
            window.open(that.links.privacy_policy, '_blank');
        });
        $('.service_agreement').click(function(event) {
            window.open(that.links.service_agreement, '_blank');
        });

        $('.cancel').click(function(event) {
            $('.msg').fadeOut();
        });
        $('.close_float').click(function(event) {
            $('.float_pop').fadeOut();
            event.stopPropagation();
        });

        $('.index .content-01 .tv_box .tv .play').click(function(event) {
            var $element = $('.video_box_pop');
            var height = $element.height();
            var width = $element.width();
            var Media = $('#media-play');
            Media.attr(
                'src',
                'https://www.youtube.com/embed/gqP7LZk2cEY?si=7-zUNQ0h_VGwKZWL'
            );
            $('.video_wrap').fadeIn();
            Media.css({
                height: `${height * 0.88}px`,
                width: `${width * 0.94}px`,
                left: `3%`,
                top: `6%`,
                position: 'absolute',
            });
        });
        $('.close').click(function(event) {
            close();
        });

        function close() {
            $('.popup_wrap').fadeOut();
            $('.close').removeClass('closeAni');
        }
    },
    swiper: function() {
        let that = this;
        var index = this.getQueryVariable('index') || 0;

        function isNumeric(str) {
            return /^\d+$/.test(str);
        }

        if (!isNumeric(index)) {
            indexArr.indexOf(index) > -1 ?
                (index = indexArr.indexOf(index)) :
                (index = 0);
        }
        var swiperH = new Swiper('.swiper-container-h', {
            direction: 'vertical',
            resistanceRatio: 0,
            mousewheelControl: true,
            autoHeight: true, // 启用自动高度
            speed: 500,
            threshold: 50,
            slidesPerView: 'auto',
            initialSlide: index,
            sensitivity: 3,
            onInit: function(swiper) {
                swiperAnimateCache(swiper);
                swiperAnimate(swiper, 'swiper');
                $('.index .head .logo').click(function(e) {
                    swiperH.slideTo(0, 500, true);
                });
                $('.menu_item').click(function(e) {
                    $(this).addClass('active').siblings().removeClass('active');
                    let menu_item = $(this).closest('.menu_item');
                    let index = $('.menu_item').index(menu_item);

                    swiperH.slideTo(index, 500, true);
                });
            },
            onSlideChangeStart(swiper) {
                swiperAnimate(swiper);
                let index = swiper.realIndex;
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
                swiperIndex = JSON.parse(JSON.stringify(swiper.realIndex));
                if (swiperIndex > 4) swiperIndex = swiperIndex - 1;
                console.log(swiperIndex);
                var activeItem = $('.menu_item').eq(swiperIndex);
                activeItem.addClass('active');
                activeItem.siblings('.menu_item').removeClass('active');

                if (swiper.activeIndex == 1) {
                    mySwiper2.startAutoplay();
                }
            },
            onTouchEnd: function(swiper) {
                swiperAnimate(swiper);
            },
        });
        var mySwiper2 = new Swiper('.swiper-container-card', {
            loop: true,
            pagination: '.swiper-pagination2',
            paginationClickable: true,
            noSwiping: true,
            autoplay: 1500,
            autoplayDisableOnInteraction: false,
            nextButton: '.swiper-button-next',
            prevButton: '.swiper-button-prev',
            effect: 'coverflow',
            slidesPerView: 'auto',
            centeredSlides: true,
            initialSlide: 2,

            coverflow: {
                rotate: 0, // 旋转的角度
                stretch: 50, // 拉伸   图片间左右的间距和密集度
                depth: 120, // 深度   切换图片间上下的间距和密集度
                modifier: 1.5, // 修正值 该值越大前面的效果越明显
                slideShadows: true, // 页面阴影效果
            },
            onInit: function(swiper) {
                swiperAnimate(swiper);
                swiper.stopAutoplay();
            },
        });

        var activeSwiper = new Swiper('.swiper-container-snail_active', {
            nextButton: '.next',
            prevButton: '.prev',
            slidesPerView: 'auto',
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
            pagination: '.swiper-pagination',
            onInit: function(swiper) {
                swiperAnimateCache(swiper);
                swiperAnimate(swiper, 'swiper');
                $('.next_btn').click(function() {
                    swiper.slideNext();
                });
                $('.done_btn').click(function() {
                    const data =
                        snail_obj.imgSrc +
                        'snail-' +
                        snail_obj.snail +
                        '-' +
                        snail_obj.shell +
                        '.png';
                    $('.snail_wrap').fadeIn();
                    $('.snail_wrap img').attr('src', data);
                });
            },
        });
        var charitySwiper = new Swiper('.swiper-container-feature', {
            grabCursor: true,
            centeredSlides: true,
            nextButton: '.next',
            prevButton: '.prev',
            slidesPerView: 'auto',
            autoplayDisableOnInteraction: false,
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
            pagination: '.swiper-pagination',
        });
        this.snailSwipwer = new Swiper('.swiper-container-snail', {
            loop: true,
            nextButton: '.next',
            prevButton: '.prev',
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
        });
        videoSwipwer = new Swiper('.swiper-container-video', {
            nextButton: '.next',
            prevButton: '.prev',
            prevButton: '.swiper-button-prev',
            nextButton: '.swiper-button-next',
            pagination: '.swiper-pagination',
            initialSlide: 1,
            onInit: function(swiper) {
                swiperAnimateCache(swiper);
                swiperAnimate(swiper, 'swiper');
                $('.main05_menu_item').click(function(e) {
                    $(this).addClass('active').siblings().removeClass('active');
                    let menu_item = $(this).closest('.main05_menu_item');
                    let index = $('.main05_menu_item').index(menu_item);
                    videoSwipwer.slideTo(index, 500, true);
                });
            },
            onSlideChangeEnd: function(swiper) {
                swiperAnimate(swiper);
                swiperIndex = swiper.realIndex;
                var activeItem = $('.main05_menu_item').eq(swiperIndex);
                activeItem.addClass('active');
                activeItem.siblings('.main05_menu_item').removeClass('active');
            },
        });
    },
    fixArea: function() {
        let resizeTimer;
        let scale = 1;

        function resizeWindow() {
            let width = $(window).width();
            let height = $(window).height();
        }
        resizeWindow();
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                resizeWindow();
            }, 300);
        });
    },

    getQueryVariable: function(variable) {
        if (window.location.href.indexOf('?') !== -1) {
            var query = window.location.href.split('?')[1];
            var vars = query.split('&');
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split('=');
                if (pair[0] == variable) {
                    return pair[1];
                }
            }
            return false;
        } else {
            return null;
        }
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                // console.log(e)
            }
        }, 500);
    },
    onAjax: function(options) {
        const { url, type, success, error, data, async } = options;
        $.ajax({
            url: url,
            type: type,
            data: data,
            async: async ? async : false,
            success: function(json) {
                success && success(json);
            },
            error: function(err) {
                layer.msg(err.message);
                error && error(err);
            },
        });
    },
};